<template>
    <div class="text-center">
<!--        <h1>403 Forbidden</h1>-->
        <figure>
            <img src="@/assets/error/error_403.jpg" class="mx-auto"/>
            <figcaption class="text-sm-left">Source from: https://dribbble.com/antacle</figcaption>
        </figure>
    </div>
</template>

<script>
    export default {
        name: "ErrorForbidden.vue"
    }
</script>

<style scoped>

</style>